export const QUERY_STALE_TIME = {
  detail: 30 * 1000,
  permission: 5 * 60 * 1000,
  sseStatus: Infinity,
  groupsList: 60 * 1000,
  preCheck: 30 * 1000,
} as const;

export const QUERY_GC_TIME = {
  detail: 10 * 60 * 1000,
  permission: 10 * 60 * 1000,
  sseStatus: Infinity,
  groupsList: 10 * 60 * 1000,
  preCheck: 10 * 60 * 1000,
} as const;

export const remoteControlKeys = {
  all: ['bi-directional'] as const,
  detail: (equipmentId: string) => [...remoteControlKeys.all, equipmentId] as const,
  permission: (assetId: string) => [...remoteControlKeys.all, 'permission', assetId] as const,
  sseStatus: (serialNumber: string) => ['remote-control', 'sse-status', serialNumber] as const,
  groupsList: (assetId: string) => [...remoteControlKeys.all, 'groups-list', assetId] as const,
  preCheckAll: () => [...remoteControlKeys.all, 'pre-check'] as const,
  preCheck: (equipmentId: string) => [...remoteControlKeys.preCheckAll(), equipmentId] as const,
};

export const remoteControlMutationKeys = {
  equipmentAction: (equipmentId: string) =>
    [...remoteControlKeys.all, 'equipment-action', equipmentId] as const,
  groupAction: (equipmentId: string) =>
    [...remoteControlKeys.all, 'group-action', equipmentId] as const,
};
